<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/cat.svg" height="150" width="150">
    <shogi-board pageTitle="AlphaSho"/>
  </div>
</template>

<script>
import shogiBoard from './components/shogiBoard.vue'

export default {
  name: 'app',
  components: {
    shogiBoard
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
